export default __webpack_public_path__ + "static/media/cha_healer_warfarin.d90accae.png";